import { TFunction } from 'i18next'

export const formatGuestInformationContent = (
	t: TFunction<'room-page', 'reservationTab.guestInfo'>,
	name?: string,
	lastName?: string,
	age?: number | string
): string => {
	if (!name && !age) return t('noInfo')
	if (!name) return `${t('noName')}, ${age}`
	if (!age) return `${name} ${lastName ?? ''}`.trim()
	return `${name} ${lastName ?? ''}, ${age}`.trim()
}
